const getUsedModel = () => {
  if (typeof window !== 'undefined') {
    const urlQuery = new URLSearchParams(window.location.search)
    const model = urlQuery.get('vehicle')?.toString()
    return model
  }
  return null
}
const getUsedVrn = () => {
  if (typeof window !== 'undefined') {
    const urlQuery = new URLSearchParams(window.location.search)
    const vrn = urlQuery.get('vrn')?.toString()
    return vrn
  }
  return null
}
const getUsedUrl = () => {
  if (typeof window !== 'undefined') {
    const urlQuery = new URLSearchParams(window.location.search)
    const url = urlQuery.get('url')?.toString()
    return url
  }
  return null
}
const getUsedDealer = () => {
  if (typeof window !== 'undefined') {
    const urlQuery = new URLSearchParams(window.location.search)
    const dealer = urlQuery.get('dealer')?.toString()
    return dealer
  }
  return null
}

const getUsedCarData = () => {
  const model = getUsedModel()
  const vrn = getUsedVrn()
  const url = getUsedUrl()
  const dealerId = getUsedDealer()

  const usedCarData = {
    model,
    vrn,
    url,
    dealerId,
  }

  return usedCarData
}

export default getUsedCarData
